<span class="dsh-button-content"><ng-content></ng-content></span>
